import { padZero } from './../utils';
import {
    SET_FLIGHTS_OPTION,
    FETCH_FLIGHTS_SUCCESS, FETCH_FLIGHTS_FAIL,
    UPDATE_FLIGHT_DETAILS,
    SET_FLIGHTS_FILTERS, RESET_FLIGHTS_FILTERS,
    SET_SELECTED_FLIGHT,
} from './../actions/flight-list';

const FlightList = (state, { type, payload }) => {
    let currentDate = getInputFormatDate(new Date());
    state || (state = {
        options: {
            typeRange: 'date', // date or time
            dateFrom: currentDate,
            dateTo: currentDate,
            timeMinus: 0,
            timePlus: 2,
            autoRefresh: 2,
        },
        filters: [
            {
                key: 'flt',
                value: '',
                label: 'Flight Number',
                readonly: false,
            },
            {
                key: 'dep',
                value: '',
                label: 'From City',
                readonly: false,
            },
            {
                key: 'arr',
                value: '',
                label: 'To City',
                readonly: false,
            },
            {
                key: 'reg',
                value: '',
                label: 'Tail Number',
                readonly: false,
            },
            {
                key: 'typ',
                value: '',
                label: 'Aircraft Type',
                readonly: false,
            },
            {
                key: 'capName',
                value: '',
                label: 'Captain',
                readonly: false,
            },
            {
                key: 'foName',
                value: '',
                label: 'First Officer',
                readonly: false,
            },
        ],
        data: [],
        flights: [],
        selected: null,
    });

    let change = null;

    switch (type) {
        case SET_FLIGHTS_OPTION:
            change = { options: { ...state.options, ...payload } }
            break;
        case FETCH_FLIGHTS_SUCCESS:
            change = { data: payload, flights: filterFlights(payload, state.filters) }
            break;
        case UPDATE_FLIGHT_DETAILS:
            const { index, flight } = payload;
            let flights = [...state.flights];
            flights.splice(index, 1, flight);
            change = { flights }
            break;
        case FETCH_FLIGHTS_FAIL:
            // change = { error: payload } 
            
            change = {flights:[],error:payload }
            break;
        case SET_FLIGHTS_FILTERS:
            change = { filters: null, flights: null };
            change.filters = state.filters.map(filter => {
                if (payload.hasOwnProperty(filter.key)) {
                    filter.value = payload[filter.key];
                }
                return filter;
            });
            change.flights = filterFlights(state.data, change.filters);
            break;
        case RESET_FLIGHTS_FILTERS:
            change = { filters: null, flights: [...state.data] };
            change.filters = state.filters.map(filter => {
                filter.value = '';
                return filter;
            });
            break;
        case SET_SELECTED_FLIGHT:
            change = { selected: payload };
            break;
        default:
            break;
    }

    return { ...state, ...change };
}

export default FlightList;

function filterFlights(flights, filters) {
    filters = filters.reduce((memo, { key, value }) => {
        if (value) {
            memo[key] = value;
        }
        return memo;
    }, {});

    if (!Object.keys(filters).length) {
        return [...flights];
    }

    return flights.filter(flight => {
        for (let key in filters) {
            if (flight[key] !== filters[key]) {
                return false;
            }
        }
        return true;
    });
}

function getInputFormatDate(date) {
    return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
}